module.exports = __webpack_public_path__ + "img/img_4.56ee9948.png";